import axios from 'axios';
import React, { useState, useRef, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useAuth } from '../../../providers/auth_provider';

const SubscriptionStatusDropdown = ({ subscription, fetchSubscriptions }) => {
    const { token } = useAuth();
    const [showDropdown, setShowDropdown] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [newStatus, setNewStatus] = useState('');
    const dropdownRef = useRef(null);

    // Toggle dropdown visibility
    const toggleDropdown = (e) => {
        e.stopPropagation(); // Prevent the click from immediately triggering the document click handler
        setShowDropdown(!showDropdown);
    };

    // Handle status change
    const handleStatusChange = (status) => {
        setNewStatus(status);
        setShowModal(true);
        setShowDropdown(false);
    };

    // Confirm status change
    const confirmStatusChange = async () => {
        try {
            await axios.put(`${process.env.REACT_APP_API_URL}/plan/update/${subscription.id}`,
                { status: newStatus },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            fetchSubscriptions();
            setShowModal(false);
            toast.success('Subscription updated successfully');
        } catch (error) {
            toast.error(error.data?.message || 'Something went wrong');
        }
    };

    // Handle clicks outside dropdown and modal
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Close dropdown if click is outside dropdown
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        // Add event listener when either dropdown or modal is shown
        if (showDropdown) {
            document.addEventListener('click', handleClickOutside);
        }
        // Cleanup
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [showDropdown]);


    return (
        <div className="dropdown" ref={dropdownRef}>
            <button
                className={`btn btn-sm text-capitalize`}
                onClick={toggleDropdown}
            >
                {subscription.status}
            </button>

            {showDropdown && (
                <ul className="dropdown-menu show">
                    <li>
                        <button className="dropdown-item" onClick={() => handleStatusChange('active')}>
                            Active
                        </button>
                    </li>
                    <li>
                        <button className="dropdown-item" onClick={() => handleStatusChange('inactive')}>
                            Inactive
                        </button>
                    </li>
                    {/* <li>
                        <button className="dropdown-item" onClick={() => handleStatusChange('suspended')}>
                            Suspended
                        </button>
                    </li> */}
                </ul>
            )}

            {/* Confirmation Modal */}
            {showModal && (
                <div className="modal show" style={{ display: 'block' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirm Status Change</h5>
                                <button type="button" className="btn" style={{ marginLeft: "auto" }} onClick={() => setShowModal(false)}>
                                    <i className="ri-close-large-line"></i>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p>Are you sure you want to change the status to <strong>{newStatus}</strong>?</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                                    Cancel
                                </button>
                                <button type="button" className="btn btn-primary" onClick={confirmStatusChange}>
                                    Confirm
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SubscriptionStatusDropdown;